var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFensterSperren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Sperren__Icn/40px/Fenster-Sperren",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Fenster-Sperren__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Fenster-Sperren__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13,10 L13,12 L9,12 L9,26 L11,26 L11,28 L9,28 C7.8954305,28 7,27.1045695 7,26 L7,12 C7,10.8954305 7.8954305,10 9,10 L13,10 Z M31,10 C32.1045695,10 33,10.8954305 33,12 L33,26 C33,27.1045695 32.1045695,28 31,28 L29,28 L29,26 L31,26 L31,12 L27,12 L27,10 L31,10 Z M20,11.3257654 C22.8756697,11.3257654 24.8943473,13.2104016 24.9959786,16.3340588 L25,16.5832257 L25.000703,17.0815253 C25.5829319,17.2778267 26,17.8068127 26,18.4285714 L26,25.5714286 C26,26.3604068 25.3284271,27 24.5,27 L15.5,27 C14.6715729,27 14,26.3604068 14,25.5714286 L14,18.4285714 C14,17.8064584 14.4175435,17.2772239 15.0002925,17.08119 L15,16.5832257 C15,13.3108981 17.0486548,11.3257654 20,11.3257654 Z M24,18.9997654 L16,18.9997654 L16,24.9997654 L24,24.9997654 L24,18.9997654 Z M20,19.6463216 C20.8284271,19.6463216 21.5,20.3178945 21.5,21.1463216 C21.5,21.5900549 21.3073236,21.9887862 21.0010701,22.2634162 L21,24 L19,24 L18.9999005,22.2642858 C18.6930836,21.9896283 18.5,21.5905235 18.5,21.1463216 C18.5,20.3178945 19.1715729,19.6463216 20,19.6463216 Z M20,13.3257654 C18.2035325,13.3257654 17.0794351,14.3549819 17.0040472,16.3642041 L17,16.5832257 L17,16.9997654 L23,16.9997654 L23,16.5832257 C23,14.4298101 21.8606271,13.3257654 20,13.3257654 Z",
    id: ".._.._src_svg_Icn_40px_Fenster-Sperren__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFensterSperren);
export default __webpack_public_path__ + "static/media/Fenster-Sperren.468cf4732ccc58c84a0df4ee51be4e52.svg";
export { ForwardRef as ReactComponent };